<div class="rounded-3xl border border-gray-200/80 bg-white/40 p-4 shadow-sm dark:border-[#191e3a] dark:bg-dark/10 md:p-6">
  <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
    <h3 class="text-sm font-semibold text-gray-800 dark:text-white">Active package</h3>
    <button
      type="button"
      class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-medium dark:border-[#191e3a] dark:bg-[#0e1726]"
      [disabled]="refreshing"
      (click)="refresh.emit()"
    >
      <span *ngIf="refreshing" class="inline-block size-3 animate-spin rounded-full border-2 border-gray-400/40 border-t-gray-700 dark:border-t-white"></span>
      Refresh
    </button>
  </div>

  <p *ngIf="loading" class="text-sm text-gray-500">Loading active package…</p>

  <div *ngIf="!loading && empty" class="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
    No active rule package for this scope. Use <strong>Activate country pack</strong> above to bootstrap defaults (v1).
  </div>

  <div *ngIf="!loading && !empty && active">
    <div class="mb-4 flex flex-wrap items-center gap-2 text-sm">
      <span class="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200">
        ● Active · v{{ active.version_seq }}
      </span>
      <span class="text-gray-500 dark:text-gray-400">{{ active.country_code }} · activated {{ active.activated_at | date: 'medium' }}</span>
    </div>
    <app-rule-config-view [config]="active.configuration" [lockedKeys]="lockedKeys"></app-rule-config-view>
  </div>
</div>
